export default __webpack_public_path__ + "static/gear-1fc88afdd168bd23c1471c421f41c5f3.svg";